import React from "react";
import { sbEditable } from "@storyblok/storyblok-editable";
import { getStyleCss } from "../helper/css_style";

function H1({ blok }) {
  let styles = {};

  if (blok?.custom_style?.length > 0) {
    styles = getStyleCss(blok.custom_style, styles);
  }

  return (
    <h1
      {...sbEditable(blok)}
      className={`${blok.className} dark:grayscale dark:text-typography-primary`}
      style={styles}
    >
      {blok.body}
    </h1>
  );
}

export default H1;
